import { useNavigate } from "react-router-dom";
import { auth } from "services";

const Menu = () => {
  let navigate = useNavigate();

  const logout = () => {
    auth.logout();
    location.replace("/login");
  };

  const gotopage = (page) => {
    navigate(page);
  };

  return (
    <ul className="list-unstyled text-dark">
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/profile")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-person-circle pe-1"></i> Profile
        </button>
      </li>
      <li className="my-3 d-block d-md-none">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/reports")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-bar-chart-line-fill pe-1"></i> Reports
        </button>
      </li>
      <li className="my-3 d-block d-md-none">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/collections")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-cash pe-1"></i> Collections
        </button>
      </li>
      <li className="my-3 disabled opacity-50 d-block d-md-none">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/passbook")}
          data-bs-dismiss="offcanvas"
          disabled
        >
          <i className="bi bi-bank pe-1"></i> Passbook
        </button>
      </li>
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/settings")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-gear pe-1"></i> Settings
        </button>
      </li>
      <li className="my-3">
        <button
          className="fs-4 btn btn-outline-app w-100 text-start mb-1 py-3"
          onClick={() => gotopage("/help")}
          data-bs-dismiss="offcanvas"
        >
          <i className="bi bi-info-circle-fill pe-1"></i> Help & Support
        </button>
      </li>
      <li className="my-3 mx-1">
        <button
          className="fs-5 btn btn-app w-100 text-start py-3"
          onClick={logout}
          data-bs-dismiss="offcanvas">
          <i className="bi bi-arrow-left pe-1"></i>
          <span className="fs-3 ms-2">Logout</span>
        </button>
      </li>
    </ul>
  );
};

export default Menu;